var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTooltip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 30,
  viewBox: "0 0 28 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_971_51319)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.066 19.066C19.1098 21.0223 16.7545 22 14.0004 22C11.2455 22 8.89025 21.0223 6.934 19.066C4.97775 17.1105 4 14.7553 4 12.0004C4 9.24546 4.97775 6.89025 6.934 4.934C8.89025 2.9785 11.2455 2 14.0004 2C16.7545 2 19.1098 2.9785 21.066 4.934C23.0223 6.89025 24 9.24546 24 12.0004C24 14.7553 23.0223 17.1105 21.066 19.066ZM7.78103 18.219C9.50229 19.941 11.5764 20.8016 14.0004 20.8016C16.4244 20.8016 18.4977 19.941 20.219 18.219C21.9402 16.4977 22.8016 14.4251 22.8016 12.0004C22.8016 9.57641 21.9402 7.5038 20.219 5.78103C18.4977 4.05977 16.4244 3.19839 14.0004 3.19839C11.5764 3.19839 9.50229 4.05977 7.78103 5.78103C6.05978 7.5038 5.19839 9.57641 5.19839 12.0004C5.19839 14.4251 6.05978 16.4977 7.78103 18.219ZM13.9422 8.87481C13.6726 8.87481 13.4296 8.76667 13.2133 8.55111C12.997 8.28074 12.8889 8.02444 12.8889 7.78074C12.8889 7.4037 13.0244 7.09259 13.2941 6.84963C13.537 6.57926 13.8748 6.44444 14.3067 6.44444C14.6044 6.44444 14.86 6.55259 15.0763 6.76815C15.2652 6.95778 15.36 7.20074 15.36 7.49778C15.36 7.90296 15.2385 8.22667 14.9955 8.46963C14.7526 8.74 14.4015 8.87481 13.9422 8.87481ZM14.4578 16.5081C14.4311 16.5356 14.417 16.5889 14.417 16.6704C14.417 16.8867 14.4978 16.9941 14.66 16.9941C14.7681 16.9941 14.8489 16.9815 14.9029 16.9533C14.9296 16.9267 14.9904 16.8926 15.0852 16.8526C15.18 16.8119 15.2541 16.7652 15.3081 16.7104L15.4704 17.1563C15.3348 17.3726 15.0918 17.5889 14.7407 17.8044C14.417 18.0474 14.0118 18.1689 13.5259 18.1689C13.0941 18.1689 12.7563 18.0881 12.5133 17.9259C12.297 17.7637 12.1889 17.5481 12.1889 17.2778V17.1563L12.5533 14.4015L12.9185 11.5252L12.1481 11.12L12.2704 10.5126L14.9437 10.1481L15.3081 10.3104L14.4578 16.5081Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_971_51319",
  x: -2,
  y: 0,
  width: 32,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_971_51319"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_971_51319",
  result: "shape"
})))));
export default SvgIconTooltip;